import React from "react";
import clsx from "clsx";

import Checkbox from "@material-ui/core/Checkbox";
import CheckIcon from "@material-ui/icons/Check";

import useStyles from "./styles";

const GreenCheckbox = props => {
  const classes = useStyles();
  const renderCheckedCheckbox = () => {
    return (
      <span className={clsx(classes.checkbox, classes.checkedCheckbox)}>
        <CheckIcon className={classes.icon} />
      </span>
    );
  };

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={renderCheckedCheckbox()}
      icon={<span className={classes.checkbox} />}
      inputProps={{ "aria-label": "decorative checkbox" }}
      {...props}
    />
  );
};

export default GreenCheckbox;
